import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'
import Select from 'react-select'
import chroma from 'chroma-js'
import _ from 'lodash'

const tableStyle = {
  backgroundColor: '#ffffff',
  marginBottom: '50px',
}

const tbodyStyle = {
  display: 'block',
  maxHeight: '300px',
  overflowY: 'scroll',
}

const tbody2Style = {
  display: 'block',
  maxHeight: '250px',
  overflowY: 'scroll',
}

const colourStyles = {
  control: styles => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = chroma(data.value)
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
          ? data.value
          : isFocused
            ? color.alpha(0.1).css()
            : null,
      color: isDisabled
        ? '#ccc'
        : isSelected
          ? chroma.contrast(color, 'white') > 2
            ? 'white'
            : 'black'
          : data.value,
      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? data.value : color.alpha(0.3).css()),
      },
    }
  },
  input: styles => ({ ...styles, ...dot() }),
  placeholder: styles => ({ ...styles, ...dot() }),
  singleValue: (styles, { data }) => ({ ...styles, ...dot(data.value) }),
}

const dot = (color = '#ccc') => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: 'block',
    marginRight: 8,
    height: 10,
    width: 10,
  },
})

class LegendTeamsoncall extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      options: props.oncall.teams,
    }
  }

  renderHeader() {
    return <Fragment><th key="legend" colSpan="2" style={{borderTopWidth: '0px'}}><h3>Legend</h3></th></Fragment>
  }

  renderData() {
    const myData = [].concat(Object.values(this.props.oncall.colors))
    return Object.keys(myData).map((key) => {
      const color = myData[key]
      return <tr key={key}><td>{color['description']}</td><td><div className="col-sm-6 bd-placeholder-img rounded" style={{backgroundColor: color['name'], height: '32px', width: '92px', display: 'inline-block'}}></div></td></tr>
    }
    )
  }

  renderHeaderMembers() {
    return <Fragment><th key="members" style={{borderTopWidth: '0px'}}><h3>Members</h3></th><th key="members_number" style={{borderTopWidth: '0px'}}><h3>{this.props.oncall.number_members}</h3></th></Fragment>
  }

  renderDataMembers() {
    const myData = [].concat(Object.values(this.props.oncall.members))
    return Object.keys(myData).map((key) => {
      const member = myData[key]
      const teamcolor = this.props.oncall.team['color']
      return <tr key={key}><td style={{ color: member['name'] !== 'You' ? 'black' : teamcolor}}>{member['name']}</td><td style={{ color: member['name'] !== 'You' ? 'black' : teamcolor}}>{member['number']}</td></tr>
    }
    )
  }

  renderReminderLink() {
    const team = this.props.oncall.team
    const l = '/teams/' + team['id'] + '/reminder'
    if (this.props.oncall.team.oncall) {
      return <a href={l} className="btn btn-secondary btn-sm col-sm-12" style={{ display: this.props.oncall.is_manager === true ? 'block' : 'none'}}>Set reminder</a>
    } else {
      return <h5>This is not an OnCall Team</h5>
    }
  }

  render() {
    if (this.props.oncall.colors) {
      const index = _.findIndex(this.props.oncall.teams, {id: this.props.oncall.team['id']})
      return <div className="row"><Select id="myteams" name="teams" className="col-md-10" options={this.state.options} styles={colourStyles} placeholder={'Teams'} defaultValue={this.state.options[index]} onChange={(se) => window.location.href = '/teams/' + se.id.toString()}></Select><div className="col-sm-12" style={{paddingTop: '10px'}}>{this.renderReminderLink()}</div><table className="table" style={tableStyle}><tbody style={tbodyStyle}><tr>{this.renderHeader()}</tr>{this.renderData()}</tbody></table><div style={{height: '30px'}}></div><table className="table" style={tableStyle}><tbody style={tbody2Style}><tr>{this.renderHeaderMembers()}</tr>{this.renderDataMembers()}</tbody></table></div>
    }
    return <div>Waiting</div>
  }
}

LegendTeamsoncall.propTypes = {
  oncall: PropTypes.object,
}

export default LegendTeamsoncall
